import script from "./Quiz.vue?vue&type=script&setup=true&lang=ts"
export * from "./Quiz.vue?vue&type=script&setup=true&lang=ts"

import "./Quiz.vue?vue&type=style&index=0&id=44905a06&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\skinner\\new_wp\\quiz-plugin\\wp-vue-quiz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44905a06"]])

export default __exports__